import L10n from './l10n';

const translations = {
  en: {
    minutes_reading: minutes => `${minutes} min read`,
    less_than_min: () => '~1 min read',
    toggle_highlights: () => 'Toggle highlights',
    powered_by: () => 'Powered by Kjuicer',
    legal_info: () => 'Kjuicer offers a simplified access to contents, but terms applied are those in the complete version of the document, shown by pressing the white button.',
    understand: () => 'I understand',
  },
  it: {
    minutes_reading: minutes => `${minutes} min di lettura`,
    less_than_min: () => '~1 min di lettura',
    toggle_highlights: () => 'Mostra/Nascondi evidenziature',
    powered_by: () => 'Offerto da Kjuicer',
    legal_info: () => 'Kjuicer offre una modalità semplificata di accesso ai contenuti, ma i termini che fanno fede sono quelli della versione completa di questo documento, accessibile con il tasto bianco in basso.',
    understand: () => 'Ho capito',
  },
};

translations['it-IT'] = { ...translations.it };

export default new L10n(translations);
